import Axios from '../axios-instance';

const userAPI = {
  getUsers: body => {
    return Axios.post('/Users/GetAll', body).then(({ data }) => data);
  },
  getUserById: id => {
    return Axios.get(`/Users/${id}`).then(({ data }) => data);
  },
  saveUser: (id, body) => {
    return Axios.put(`/Users/${id}`, body).then(({ data }) => data);
  },
  newUser: body => {
    return Axios.post('/Users', body).then(({ data }) => data);
  },
  changeUserSettings: body => {
    return Axios.put('/Users/ChangeSettings', body).then(({ data }) => data);
  },

};

export default userAPI;
